import { cn } from "@/lib/utils"
import { Button } from "@/components/ui/button"
import { useForm } from "@inertiajs/react"
import { usePage } from "@inertiajs/react";
import { FormField } from "@/components/core/form_field"
import { Link } from "@inertiajs/react"
import { Head } from "@inertiajs/react"

export default function ResetPassword({ className, errors, reset_password_token, ...props }) {
  const url = new URL(window.location)
  const token = url.searchParams.get("reset_password_token")

  const { data, setData, patch, transform, processing } = useForm({
    password: '',
    password_confirmation: '',
    reset_password_token: token
  })

  const { flash } = usePage().props

  const handleSubmit = (event) => {
    event.preventDefault()
    transform(data => ({ user: data }))
    patch("/password")
  }

  return (
    <>
      <Head>
        <title>founder/mode | Reset Password</title>
      </Head>
      <div className="flex min-h-svh flex-col items-center justify-center gap-6 bg-background p-6 md:p-10">
        <div className="w-full max-w-sm">
          <div className={cn("flex flex-col gap-6 p-6 rounded-lg shadow", className)} {...props}>
            <form onSubmit={handleSubmit}>
              <div className="flex flex-col gap-6">
                <div className="flex flex-col items-center gap-2">
                  <Link
                    href="#"
                    className="flex flex-col items-center gap-2 font-medium"
                  >
                    <span className="sr-only">founder/mode</span>
                  </Link>
                  <h1 className="text-xl font-bold">Reset your password</h1>
                  <div className="text-center text-sm">
                    Remember your password?{" "}
                    <Link href="/login" className="underline underline-offset-4">
                      Login
                    </Link>
                  </div>
                </div>
                <div className="flex flex-col gap-6">
                  <div className="flex flex-col gap-3">
                    <FormField
                      label="New Password"
                      name="password"
                      type="password"
                      placeholder="********"
                      value={data.password}
                      onChange={(e) => setData('password', e.target.value)}
                      errors={errors}
                    />

                    <FormField
                      label="Confirm New Password"
                      name="password_confirmation"
                      type="password"
                      placeholder="********"
                      value={data.password_confirmation}
                      onChange={(e) => setData('password_confirmation', e.target.value)}
                      errors={errors}
                    />

                    {flash.alert && (
                      <p className="text-[0.8rem] mt-1 font-medium text-destructive">{flash.alert}</p>
                    )}
                  </div>
                  <Button type="submit" className="w-full" disabled={processing}>
                    Reset Password
                  </Button>
                </div>
              </div>
            </form>
            <div className="text-balance text-center text-xs text-muted-foreground [&_a]:underline [&_a]:underline-offset-4 hover:[&_a]:text-primary">
              By clicking continue, you agree to our <a href="#">Terms of Service</a>{" "}
              and <a href="#">Privacy Policy</a>.
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
